import { render, staticRenderFns } from "./backward.vue?vue&type=template&id=61bf0f98&"
import script from "./backward.vue?vue&type=script&lang=ts&"
export * from "./backward.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports